import moment from 'moment';
import React from 'react';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import {
    TAnnex6V2GroupA1,
    odsEquipmentActivitiesCodes,
} from '../../../../../../../redux/app/annex6-v2/groups/group-a';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupA1PreviewProps = OwnProps;

function Annex6V2GroupA1Preview(props: Annex6V2GroupA1PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupA1;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const odsActivity = record.itemA1P3.activity;
    const activityObj = odsEquipmentActivitiesCodes.find(
        (activity) => activity.value === odsActivity
    );

    function renderMain() {
        return (
            <Annex6V2TableRows
                record={record}
                tableRows={[
                    [operationDate, 'A', '1', renderItemA1P1()],
                    [null, null, '2', renderItemA1P2()],
                    [null, null, activityObj?.code || '3', renderItemA1P3()],
                    [null, null, '4', renderItemA1P4()],
                    [null, null, 'NOTE', record.remarks],
                ]}
                theme={props.theme}
            />
        );
    }

    function renderItemA1P1() {
        const { initialChargeOfSystem, systemIdentification, typeOfODS } =
            record.itemA1P1;
        return (
            <h4 className="font-medium uppercase">
                System: {systemIdentification}, ODS Type: {typeOfODS}, Initial
                Charge: {initialChargeOfSystem} kgs
            </h4>
        );
    }

    function renderItemA1P2() {
        const { date: smtDate, time: smtTime } = record.itemA1P2;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);
        return (
            <h4 className="font-medium uppercase">
                {utcTime.format('HH:mm')} hrs UTC on{' '}
                {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')})
            </h4>
        );
    }

    function renderItemA1P3() {
        return (
            <h4 className="font-medium uppercase">
                Activity: {record.itemA1P3.activity}
            </h4>
        );
    }

    function renderItemA1P4() {
        const { finalCharge, chargeAdded, chargeRemoved } = record.itemA1P4;
        const { initialChargeOfSystem } = record.itemA1P1;

        return (
            <h4 className="font-medium uppercase">
                Charge Added: {chargeAdded} kgs, Charge Removed: {chargeRemoved}{' '}
                kgs, Final Charge: {finalCharge + initialChargeOfSystem} kgs
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupA1Preview;
